<div class="reviews-outer" *ngIf="true">
  <h2 class="trinidad-bold">Thank you for your review of {{ (boondock$ | async)?.name }}.</h2>
  <p class="wizard-paragraph _12px">
    Great! Now that you have reviewed the site our team will review the information and get the site updated.
  </p>
  <img src="/img/wf/Thanks_CNT.svg" loading="lazy" alt="Thanks" />
  <div class="button-wrapper">
    <a role="button" class="button trinidad center w-button" (click)="onComplete()">
      <span *ngIf="appContext">Home</span>
      <span *ngIf="!appContext">Close</span>
    </a>
  </div>
</div>
